import { useState } from 'react';
import { ApiErr, signIn, verifyEmail, type Env, type PendingVerification } from '../lib/api';
import { Icon } from '../ui/Icons';

export function SignIn({ env, envs, setEnv, dark, reason, onSignedIn }: { env: Env; envs: Env[]; setEnv: (k: string) => void; dark: boolean; reason?: string; onSignedIn: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [pending, setPending] = useState<PendingVerification | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(reason && reason !== 'signed out' ? reason : null);
  const go = async () => {
    setBusy(true); setErr(null);
    try {
      if (pending) { await verifyEmail(env, pending, code.trim()); } else {
        const p = await signIn(env, email.trim(), password);
        if (p) { setPending(p); setBusy(false); return; }
      }
      onSignedIn();
    } catch (e) {
      setErr((e as ApiErr).message);
    } finally {
      setBusy(false);
    }
  };
  const v = env.key === 'production' ? 'prod' : env.key === 'e2e' ? 'e2e' : 'local';
  return (
    <div className="login">
      <img src={dark ? '/vocalstack-logo-dark.svg' : '/vocalstack-logo.svg'} alt="VocalStack" style={{ width: 292, height: 'auto' }} />
      <form className="login__card" onSubmit={(e) => { e.preventDefault(); void go(); }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span className="adm__tag">ADMIN</span>
          <div className="seg" style={{ marginLeft: 'auto' }}>
            {envs.map((e) => <button key={e.key} type="button" className={`seg__opt ${e.key === env.key ? 'seg__opt--on' : ''}`} onClick={() => { setEnv(e.key); setPending(null); setErr(null); }}>{e.label}</button>)}
          </div>
        </div>
        <div>
          <div style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-.3px' }}>{pending ? 'Check your email' : `Sign in to ${env.label}`}</div>
          <div style={{ fontSize: 12.5, fontWeight: 300, color: 'var(--ink-55)', marginTop: 4 }}>{pending ? `A 6-digit code was sent to ${pending.email}.` : <>The admin account of <span className="mono" style={{ color: `var(--env-${v})` }}>{env.host}</span>.</>}</div>
        </div>
        {pending ? (
          <label className="field"><span className="field__label">Verification code</span><input className="field__input mono" autoFocus inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} /></label>
        ) : (
          <>
            <label className="field"><span className="field__label">Email</span><input className="field__input" type="email" autoFocus autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} /></label>
            <label className="field"><span className="field__label">Password</span><input className="field__input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} /></label>
          </>
        )}
        {err && <div className="login__err" role="alert"><Icon name="warn" size={16} style={{ color: 'var(--conf-low)', flex: 'none', marginTop: 1 }} /><span>{err}</span></div>}
        <button type="submit" className="btn btn--primary" style={{ height: 40 }} disabled={busy || (pending ? code.trim().length < 4 : !email || !password)}>{busy ? 'Signing in…' : pending ? 'Verify' : 'Sign in'}</button>
        {pending && <button type="button" className="btn btn--link" onClick={() => setPending(null)}>Back</button>}
      </form>
    </div>
  );
}
